import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';
import faker from 'faker';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import HeaderPage from './HeaderPage';
import CrewDraftContainer from '../containers/CrewDraftContainer';
import AddParticipants from '../components/AddParticipants';
import DescriptiveCard from '../components/DescriptiveCard';
import Footer from '../components/Footer';
import DraftParentsGroup from '../components/DraftParentsGroup';
import session from '../models/Session';
import _ from 'lodash';

const styles = {
  promptCardWrapper: {
    margin: '0 auto',
    width: '37.5rem',
  },
  startJamLabel: {
    fontFamily: 'Lato, Arial',
    fontSize: '14px',
    color: '#34A5DA',
    marginBottom: '0.5rem',
  },
};

function SessionActivityCard(props) {
  const {
    sessions, draft, onChange, value,
  } = props;

  return sessions.map((session, sessionIndex) => (
    <DescriptiveCard key={`${draft._id}_${sessionIndex}_outer`} isShowing={true} label={`Session ${sessionIndex + 1}:`} blurb={session.description}>
      {(props.match.params.number == sessionIndex + 1) ? (
        <DraftParentsGroup key={`${draft._id}_${sessionIndex}_outer`} {...{session, onChange, value, draft, disabled: true} } />      
      ) : ''}
    </DescriptiveCard>
  ));
}

const GET_DRAFT_BY_ID = id => gql`
  query {
    draftWithParents(_id: "${id}") {
      _id
      title,
      blurb,
      image,
      isSeeded,
      createdBy {
        image 
        displayName 
        _id 
      }
      participants {
        displayName,
        image,
        _id
      },
      parents {
       image
       parentType
       prompt
       _id
       blurb
       title
       name
      }
      sessions {
        index,
        _id
        fields
      }
      template {
        _id,
        name,
        slug,
        sessions {
          description,
          _id, 
          output {
            name,
            slug,
            type,
            _id
          }
        }
      }
    }
    userMany {
      _id
      image
      displayName
    }
  }
`;

class CrewDraftPage extends Component {
  componentDidMount() {
    if (this.props.draftData) {
      this.props.draftData.setup({
        // forceNew: this.props.match.params.id === 'new' || this.props.match.params.number === 'new' 
      });
    }
  }

  componentWillUnmount() {
    this.props.draftData.destroy();
  }

  render() {
    const { classes, draftData } = this.props;

    console.log('DraftData:',this.props.draftData)

    console.log('CrewDraftPage:beforeAll', {
      draftData: draftData.state, 
      session: session.store
    });

    if (this.props.match.params.id === 'new') {
      if (!session.store.draft) {
        return (
          <Redirect to="/" />
        );
      }

      if (session.store.draft && session.store.draft.createdAt) {
        return (
          <Redirect to={`/crew/${session.store.draft._id}`} />
        );
      }
      return null;
    }

    if (!this.props.match.params.number) {
      return (
        <Redirect to={`/crew/${session.store.draft._id}/1`} />
      );
    }

    console.log('CrewDraftPage:after', this.props.draftData.state.draft);

    return (
      <Query query={GET_DRAFT_BY_ID(this.props.match.params.id)}>
        {({ loading, error, data }) => {
        if (loading) return <div>Loading...</div>;
        if (error) return <div>Error :(</div>;

          if (!data.draftWithParents) {
            return null; 
          }

          session.get('draft').set(data.draftWithParents);

          console.log(session.get('draft').toObject(), data.draftWithParents, data);

          if (data.draftWithParents) {
            if (data.draftWithParents.isSeeded || this.props.match.params.number === 'new') {
              return (<Redirect to={`/create/${data.draftWithParents.template.slug}/select/addPrompt`} />);
            }
          } 
          
          if (!(data.draftWithParents.createdBy._id === session.getUser()._id || _.some(data.draftWithParents.participants, { _id: session.getUser()._id }))) {
            return ( <Redirect to="/" /> );
          }

          return (
            <div>
              <HeaderPage titleHeader={`Crewing for ${data.draftWithParents.template.name}`} descriptionHeader={`Add users to this ${data.draftWithParents.template.name} Jam. Choose no more than 4 participants in total.`} showBtns={false} />
              <div className={classes.promptCardWrapper}>
                <AddParticipants
                  users={data.userMany || []}
                  participants={data.draftWithParents.participants}
                  leaderImage={data.draftWithParents.createdBy.image}
                  leaderName={data.draftWithParents.createdBy.displayName}
                  onAddParticipant={draftData.onAddParticipant}
                  onRemoveParticipant={draftData.onRemoveParticipant}
                />
                <HeaderPage titleHeader="Jam Sessions" descriptionHeader="Below is the agenda for the upcoming sessions." showBtns={false} />
                <div className={classes.startJamLabel}>{`Jam will start with session ${this.props.match.params.number}`}</div>
                <SessionActivityCard
                  {...this.props}
                  sessionNumber={this.props.match.params.number}
                  onChange={draftData.handleChange}
                  value={draftData.state.textbox}
                  sessions={data.draftWithParents.template.sessions}
                  draft={data.draftWithParents}
                />
                <DescriptiveCard label="Wrap Up:" blurb="The Jam Leader will be able to tweak/form any necessary changes. Note: This is not a session and any changes will be tracked." />

              </div>
              <Footer actionBtnLabel="Start Jam" onNext={draftData.onNext} to={`/crew/${this.props.match.params.id}/${this.props.match.params.number}/start`} />
            </div>
          );
        }}
      </Query>
    );
  }
}

function CrewDraftPageWrapper(props) {
  return (
    <Subscribe to={[CrewDraftContainer]}>
      { draftData => (
        <div>
          {draftData && (
          <CrewDraftPage {...props} draftData={draftData} />
          )}
        </div>
      )}
    </Subscribe>
  );
}

export default injectSheet(styles)(CrewDraftPageWrapper);



// WEBPACK FOOTER //
// ./src/pages/CrewDraftPage.js